module.exports = __webpack_public_path__ + "static/media/Bicocca - white_LT Grey.eeca013b.jpg";